import { fmt } from "@/data/catalog";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const imgUrl = (u) => (u && u.startsWith("/") ? `${BACKEND}${u}` : u);
export { fmt };

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("en-AU", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

const STATUS_STYLES = {
  paid: "bg-[#E3F0E3] text-[#4A5D4E]",
  shipped: "bg-[#E0EAF5] text-[#3E6CA8]",
  fulfilled: "bg-[#E0EAF5] text-[#3E6CA8]",
  pending: "bg-[#EFE7D6] text-[#B07A4E]",
  initiated: "bg-[#EFE7D6] text-[#B07A4E]",
  unfulfilled: "bg-[#F0E7E0] text-[#9A8E88]",
  refunded: "bg-[#F3E0DE] text-[#B0554E]",
  partially_refunded: "bg-[#F3E9DE] text-[#B07A4E]",
  cancelled: "bg-[#EDE3E0] text-[#8A6A63]",
};

export const StatusBadge = ({ status }) => (
  <span className={`rounded-full px-3 py-1 text-[0.6rem] font-semibold uppercase tracking-wider ${STATUS_STYLES[status] || "bg-[#F0E7E0] text-[#9A8E88]"}`}>
    {(status || "—").replace(/_/g, " ")}
  </span>
);

export const Card = ({ children, className = "" }) => (
  <div className={`rounded-3xl border border-[#E5DBC8] bg-white p-6 shadow-[0_8px_30px_-12px_rgba(213,142,120,0.25)] ${className}`}>{children}</div>
);

export const Spinner = () => (
  <div className="flex justify-center py-16">
    <div className="h-6 w-6 animate-spin rounded-full border-2 border-[#FBC4A8] border-t-transparent" />
  </div>
);
